import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
/**
 * AgentBubble — chat message bubble for the Ask surface, dossier chat,
 * and the agent-led onboarding variant. Two visual states:
 *   - `who="agent"` — filled surface-2 bubble (the default)
 *   - `who="user"`  — transparent bubble with line-2 border
 *
 * Optional `eyebrow` renders an uppercase-mono label above the body
 * ("AGENT · 2 min ago" / "YOU"). The leading dot in the eyebrow uses
 * the `AgentAvatar` for agent turns; user turns get no avatar.
 */
export function AgentBubble({ who = 'agent', eyebrow, children, className, }) {
    return (_jsxs("div", { className: cn('relative mb-3.5 rounded-3 border p-5 leading-relaxed', who === 'agent'
            ? 'border-[var(--color-line)] bg-[var(--color-surface-2)] text-[var(--color-ink)]'
            : 'border-[var(--color-line-2)] bg-transparent text-[var(--color-ink)]', className), children: [eyebrow && (_jsxs("div", { className: "mb-2 flex items-center gap-2 font-mono text-2xs uppercase tracking-[0.14em] text-[var(--color-ink-muted)]", children: [who === 'agent' && _jsx(AgentAvatar, {}), _jsx("span", { children: eyebrow })] })), _jsx("div", { className: "text-[13.5px] leading-[1.55]", children: children })] }));
}
/**
 * AgentAvatar — 18px radial-gradient dot in the accent family. Renders
 * as the leading affordance of agent-authored messages, and as the
 * sidebar "AGENT · WATCHING" indicator.
 */
export function AgentAvatar({ className }) {
    return (_jsx("span", { "aria-hidden": true, className: cn('inline-block size-4.5 rounded-pill', className), style: {
            background: 'radial-gradient(circle at 30% 30%, var(--color-accent-bright), var(--color-accent))',
        } }));
}
